export default "__VITE_ASSET__B92f4e99__"